import React from 'react';
import { Pagination, PaginationItem, PaginationLink } from 'reactstrap';

interface PageNavigationProps {
  pageIndex: number;
  canPreviousPage: boolean;
  canNextPage: boolean;
  previousPage(): void;
  nextPage(): void;
  gotoPage(page: number): void;
  pageCount: number;
  eachSide?: number;
}
/**
 * PageSizeDropwdown
 *
 */
export const PageNavigation = ({pageIndex, canPreviousPage, canNextPage, previousPage, nextPage, gotoPage, pageCount, eachSide = 2}: Readonly<PageNavigationProps>): JSX.Element | null => {

  const paginationItems = (): JSX.Element[] => {
    const paginationElements: JSX.Element[] = [];

    const fixedPages = (eachSide * 4 + 2) < 10 ? 10 : (eachSide * 4 + 2);

    // push all pages if not enough pages
    if (pageCount <= fixedPages) {
      for(let i = 0; i < pageCount; i ++){
        const active = i === pageIndex;
        paginationElements.push(
          <PaginationItem key={i} active={active}>
            <PaginationLink onClick={() => gotoPage(i)}>
              {i + 1}
            </PaginationLink>
          </PaginationItem>
        )
      }
    } else {
      // push around pageIndex
      const startIndex = (pageIndex - eachSide) < 0 ? 0 : (pageIndex - eachSide);
      const endIndex = (pageIndex + eachSide) >= pageCount ? (pageCount - 1) : (pageIndex + eachSide);
      for(let i=startIndex; i <= endIndex; i++){
        const active = i === pageIndex;
        paginationElements.push(
          <PaginationItem active={active}>
            <PaginationLink onClick={() => gotoPage(i)}>
              {i + 1}
            </PaginationLink>
          </PaginationItem>
        );
      }

      // push first and dots
      if (pageIndex > ( 0 + eachSide)){
        paginationElements.unshift(
          <PaginationItem disabled>
            <PaginationLink>
              ...
            </PaginationLink>
          </PaginationItem>
        );
        paginationElements.unshift(
          <PaginationItem>
            <PaginationLink onClick={() => gotoPage(0)}>
              1
            </PaginationLink>
          </PaginationItem>
        );
      }

      // push last and dots
      if (pageIndex < ( pageCount - 1 - eachSide)){
        paginationElements.push(
          <PaginationItem disabled>
            <PaginationLink>
              ...
            </PaginationLink>
          </PaginationItem>
        );
        paginationElements.push(
          <PaginationItem>
            <PaginationLink onClick={() => gotoPage(pageCount - 1)}>
              {pageCount}
            </PaginationLink>
          </PaginationItem>
        );
      }
    }

    return paginationElements;
  }

  if (pageCount === 0){
    return null;
  }

  return (
    <React.Fragment>
      <Pagination size="sm" listClassName="justify-content-end">
        <PaginationItem
          disabled={!canPreviousPage}>
          <PaginationLink first
            id="button-pagination-first"
            onClick={() => gotoPage(0)} />
        </PaginationItem>
        <PaginationItem
          disabled={!canPreviousPage}>
          <PaginationLink previous
            id="button-pagination-prev"
            onClick={() => previousPage()}
          />
        </PaginationItem>

        {paginationItems()}

        <PaginationItem
          disabled={!canNextPage}>
          <PaginationLink next
            id="button-pagination-next"
            onClick={() => nextPage()}
          />
        </PaginationItem>
        <PaginationItem
          disabled={!canNextPage}>
          <PaginationLink last
            id="button-pagination-first"
            onClick={() => gotoPage(pageCount - 1)} />
        </PaginationItem>
      </Pagination>
    </React.Fragment>
  );
}
PageNavigation.displayName = 'PageNavigation';
